import Accordion from '../../../../shared/Accordion';

const Professional = ({
  open,
  onToggle,
  editable,
  formDataProfesional,
  handleChange,
}) => {
  return (
    <Accordion
      id="info-profesional"
      title="Información profesional"
      open={open}
      onToggle={onToggle}
      edit={editable}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
            ¿Cuál es tu profesión?<span className="text-red-700"> *</span>
          </label>
          <input
            type="text"
            name="profession"
            value={formDataProfesional.profession}
            onChange={handleChange}
            disabled={!editable}
            className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
            required
          />
        </div>
        <div>
          <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
            ¿En qué empresa trabajas?<span className="text-red-700"> *</span>
          </label>
          <input
            type="text"
            name="company"
            value={formDataProfesional.company}
            onChange={handleChange}
            disabled={!editable}
            className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
            required
          />
        </div>
        <div className="md:col-span-2">
          <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
            ¿Cuál es tu cargo actual?<span className="text-red-700"> *</span>
          </label>
          <input
            type="text"
            name="currentPosition"
            value={formDataProfesional.currentPosition}
            onChange={handleChange}
            disabled={!editable}
            className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
            required
          />
        </div>
      </div>
    </Accordion>
  );
};

export default Professional;
